import { IPlaceOption } from 'types/IPlaceOption'

export const SET_SEARCH_TERM = 'algoliaPlacesComponent.setSearchTerm'
export const SET_OPTIONS = 'algoliaPlacesComponent.setOptions'
export const SET_IS_LOADING = 'algoliaPlacesComponent.setIsLoading'
export const SET_IS_SELECTOR_OPEN = 'algoliaPlacesComponent.setIsSelectorOpen'
export const RESET = 'algoliaPlacesComponent.reset'

export function setSearchTerm(payload: string) {
  return {
    type: SET_SEARCH_TERM,
    payload
  } as const
}

export function setOptions(payload: IPlaceOption[]) {
  return {
    type: SET_OPTIONS,
    payload
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export function setIsLoading(payload: boolean) {
  return {
    type: SET_IS_LOADING,
    payload
  } as const
}

export function setIsSelectorOpen(payload: boolean) {
  return {
    type: SET_IS_SELECTOR_OPEN,
    payload
  } as const
}

export type AlgoliaPlacesAction = ReturnType<
  typeof setSearchTerm | typeof setOptions | typeof setIsLoading | typeof setIsSelectorOpen | typeof reset
>
